import {loadLibrary} from "./Util";

loadLibrary(['/js/jquery-ui.min.js', '/js/datepicker-ru.js'], function () {
    setInterval(function(){
        //console.log($('#ui-datepicker-div:visible').length)
        if($('#ui-datepicker-div:visible').length){
            $('.datepicker_wrap').addClass('fade');
        } else {
            $('.datepicker_wrap').removeClass('fade');
        }
    }, 20);
    $(document).on('click', '.num_input a', function(){
        if($(this).hasClass('disabled') || $(this).parents('.num_input').hasClass('disabled')) return;
        var parent = $(this).parents('.num_input'),
            input = parent.find('input'),
            min = parseInt(input.attr('min')),
            max = parseInt(input.attr('max')),
            value = parseInt(input.val());
        if(isNaN(value)) value = 1;
        parent.find('a').removeClass('disabled');
        if($(this).hasClass('plus')){
            input.val(value + 1);
        } else {
            input.val(value - 1);
        }
        if(input.val() >= max || input.val() <= min){
            $(this).addClass('disabled')
        }
        if(input.val() <= min){
            parent.parents('.basket_item').addClass('disabled');
        } else {
            parent.parents('.basket_item').removeClass('disabled');
        }

    });
    $(document).on('keypress', '.num_input input', function(e){
        var input = $(this),
            min = parseInt(input.attr('min')),
            max = parseInt(input.attr('max')),
            value = parseInt(input.val());

        validate(e, value, min, max);

    });
    $(document).on('keyup', '.num_input input', function(e){
        var parent = $(this).parents('.num_input'),
            input = $(this),
            min = parseInt(input.attr('min')),
            max = parseInt(input.attr('max')),
            value = parseInt(input.val());
        if(value <= min){
            input.val(min)
            parent.find('.minus').addClass('disabled');
            parent.parents('.basket_item').addClass('disabled');
        } else {
            parent.parents('.basket_item').removeClass('disabled');
            parent.find('.minus').removeClass('disabled');
        }
        if(value >= max){
            input.val(max)
            parent.find('.plus').addClass('disabled');
        } else {
            parent.find('.plus').removeClass('disabled');
        }

    });
    var validate = function(evt, value, min, max) {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode( key );
        var regex = /[0-9]|\./;
        if( !regex.test(key) ) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    }
    if($( "#datepicker" ).length){
        $( "#datepicker" ).datepicker(
            $.datepicker.regional[ "ru" ]
        );
        $('#datepicker').datepicker( "setDate", (new Date()) );
    }

    if($('#multi_months').length){
        $('#multi_months').datepicker({
            numberOfMonths: 6,
            showCurrentAtPos: 0
        });
    }
    if($('#single_month').length){
        $('#single_month').datepicker({
            numberOfMonths: 1,
            showCurrentAtPos: 0
        });
    }
    window.calculateMenstr = function (){

        var menstrDay = $( "#datepicker" ).datepicker( "getDate" ),
            cycle = parseInt($('#calc_p_1').val()),
            mDyration = parseInt($('#calc_p_2').val());

        $( "#multi_months" ).datepicker( "setDate", menstrDay);
        $( "#single_month" ).datepicker( "setDate", menstrDay);

        var days = $('[data-handler="selectDay"]'),
            menstrDayIndex = days.index($('.ui-datepicker-current-day'));

        drawCalc(menstrDayIndex, cycle, mDyration);

        drawCalc((menstrDayIndex + cycle), cycle, mDyration);
        drawCalc((menstrDayIndex + cycle * 2), cycle, mDyration);
        drawCalc((menstrDayIndex + cycle * 3), cycle, mDyration);
        drawCalc((menstrDayIndex + cycle * 4), cycle, mDyration);
        drawCalc((menstrDayIndex + cycle * 5), cycle, mDyration);
        drawCalc((menstrDayIndex + cycle * 6), cycle, mDyration);
        $('body, html').animate({
                scrollTop: $('.calc_bottom_block').offset().top,
            },
            500, function() {
                /* stuff to do after animation is complete */
            });

    }
    function drawCalc(menstrDayIndex, cycle, mDyration){
        var ovulationDayIndex = menstrDayIndex + Math.round(cycle / 2);
        $('[data-handler="selectDay"]').slice((menstrDayIndex), (menstrDayIndex + mDyration)).addClass('menstr'); /* менструация */

        $('[data-handler="selectDay"]').eq(ovulationDayIndex).addClass('ovulation_day');
        $('[data-handler="selectDay"]').slice((ovulationDayIndex + 1), (ovulationDayIndex + 3)).addClass('ovulstion');
        $('[data-handler="selectDay"]').slice((ovulationDayIndex - 4), (ovulationDayIndex )).addClass('ovulstion');
    }

    $("#calc_form").submit(function(){return false});
    $("#calc_form input").change(function(){
        $self = $(this)
        $form = $self.closest("form")
        window.history.pushState({}, '', "?"+$form.serialize())
    });
});


